import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {exportStepperConfig} from '../../configs/export-stepper.config';
import {StepperReadyEvent} from '../../../stepper/events/stepper-ready.event';
import {StepperConfig} from '../../../stepper/stepper.config';

@Component({
    selector: 'mydocma-export-stepper',
    templateUrl: './expert-stepper.component.html',
    styleUrls: ['./export-stepper.component.scss']
})
export class ExportStepperComponent implements OnChanges {

    @Input()
    public exportItems = [];

    @Output()
    public ready = new EventEmitter<StepperReadyEvent>();

    @Output()
    public exportEvent = new EventEmitter();

    public stepperConfig: StepperConfig = exportStepperConfig;

    private stepperData: StepperReadyEvent;

    /**
     * A lifecycle hook that is called when any data-bound property of a directive changes.
     *
     * @param changes - changes
     */
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.exportItems) {
            this.initExportItems();
        }
    }

    public onReadyEvent(param: StepperReadyEvent) {
        this.stepperData = param;

        this.stepperConfig.validate = (currStep) => {
            if (currStep.index === 1) {
                return;
            }
            if (currStep.index === 0) {
                this.stepperData.executionService.end();
            }

            const step = this.stepperData.stepperService.getStepByIndex(1);
            this.stepperData.stepperService.setStepData(step, {error: null, valid: false, data: step.data}, false);
        };

        this.initExportItems();

        this.ready.emit(param);
    }

    public onExportEvent() {
        this.exportEvent.emit();
    }

    private initExportItems() {
        const stepDataMapping = this.stepperData.stepperService.getStepByName('dataMapping');
        stepDataMapping.data = this.exportItems;

        setTimeout((step) => {
            step.component.enter();
        }, 100, stepDataMapping);
    }
}
